import { render, staticRenderFns } from "./blog-search.vue?vue&type=template&id=91e52728&scoped=true"
import script from "./blog-search.vue?vue&type=script&lang=js"
export * from "./blog-search.vue?vue&type=script&lang=js"
import style0 from "./blog-search.vue?vue&type=style&index=0&id=91e52728&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91e52728",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VInput: require('/var/www/tubber-new/components/global/v/input.vue').default,VIcon: require('/var/www/tubber-new/components/global/v/icon.vue').default})
